import React from 'react';
import { motion } from 'framer-motion';
import { nistCsfFunctions } from '../../data/nistCsf';
import './NistCsf.css';

const NistCsf = () => {
  const sectionVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
  };

  return (
    <div className="nist-csf-page">
      <motion.section
        className="nist-csf-hero"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, ease: 'easeOut' }}
      >
        <span className="nist-csf-eyebrow">Framework alignment</span>
        <h1>NIST Cybersecurity Framework 2.0 Mapping</h1>
        <p>
          PassiveGuard helps security teams operationalize NIST CSF principles by mapping code,
          cloud, network, and response signals to the six CSF 2.0 functions.
        </p>
      </motion.section>

      <motion.section
        className="nist-csf-card-grid"
        initial="hidden"
        animate="visible"
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
      >
        {nistCsfFunctions.map((item) => (
          <motion.article className="nist-csf-card" key={item.id} variants={sectionVariants}>
            <span>{item.label}</span>
            <h2>{item.label.charAt(0) + item.label.slice(1).toLowerCase()}</h2>
            <p>{item.desc}</p>
          </motion.article>
        ))}
      </motion.section>

      <section className="nist-csf-mapping">
        {nistCsfFunctions.map((item) => (
          <motion.article
            className="nist-csf-mapping-card"
            key={item.id}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={sectionVariants}
          >
            <div className="nist-csf-mapping-header">
              <span>{item.label}</span>
              <h2>{item.label.charAt(0) + item.label.slice(1).toLowerCase()} Function</h2>
              <p>{item.guidance}</p>
            </div>

            <div className="nist-csf-columns">
              <div>
                <h3>Guideline principles</h3>
                <ul>
                  {item.principles.map((principle) => (
                    <li key={principle}>{principle}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h3>PassiveGuard capabilities</h3>
                <ul>
                  {item.capabilities.map((capability) => (
                    <li key={capability}>{capability}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h3>Operational outcomes</h3>
                <ul>
                  {item.outcomes.map((outcome) => (
                    <li key={outcome}>{outcome}</li>
                  ))}
                </ul>
              </div>
            </div>
          </motion.article>
        ))}
      </section>

      <section className="nist-csf-disclaimer">
        <strong>Alignment note</strong>
        <p>
          PassiveGuard supports NIST CSF alignment activities by organizing security evidence,
          risk context, and operational workflows. This page is not a claim of certification,
          legal compliance, or an official NIST assessment.
        </p>
      </section>
    </div>
  );
};

export default NistCsf;
